import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  resetButton: {
    width: 90,
    height: 30,
    color: theme.palette.text.secondary,
    borderRadius: 2,
    boxShadow: "none",
    marginRight: 18,
    textTransform: "capitalize",
    padding: "2px 2px 0",
    border: `1px solid ${theme.palette.text.hint}`,
    fontSize: 13
  },
  filtersButton: {
    position: "relative",
    padding: 0,
    color: theme.palette.text.primary
  },
  filterListIcon: {
    fontSize: 34
  },
  filterListIconActive: {
    color: theme.palette.secondary.dark
  },
  filterMark: {
    width: 11,
    height: 11,
    position: "absolute",
    top: 5,
    right: 2,
    border: "2px solid #fff",
    backgroundColor: "rgba(216, 47, 68, 1)",
    borderRadius: "50%"
  },
  filterBar: {
    display: "flex",
    alignItems: "center"
  }
}));
